<template>
    <div class="modal modal-slide-in fade" id="user-modal">
        <div class="modal-dialog">
          <form class="modal-content pt-0" id="user-form">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closer">×</button>
            <div class="modal-header mb-1">
              <h5 class="modal-title" id="exampleModalLabel">Create New User</h5>
            </div>
            <div class="modal-body flex-grow-1">
              <div class="form-group">
                <label class="form-label" for="name">Name </label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  name="name"
                  aria-label=""
                  aria-describedby="name"
                  v-model="name"
                />
                <div v-if="vuelidate.name.$error" class="error">{{vuelidate.name.$errors[0].$message}}</div>
                <!-- <ErrorHandler :error="userStore.error" keyword="name"/> -->
              </div>
              <div class="form-group">
                <label class="form-label" for="email">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  placeholder="Email"
                  name="email"
                  aria-label=""
                  aria-describedby="email"
                  v-model="email"
                />
                <div v-if="vuelidate.email.$error" class="error"> {{vuelidate.email.$errors[0].$message}} </div>
                <!-- <ErrorHandler :error="userStore.error" keyword="email"/> -->
              </div>
              <div class="form-group">
                <label class="form-label" for="password">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  name="password"
                  aria-label=""
                  aria-describedby="password"
                  v-model="password"
                />
                <div v-if="vuelidate.password.$error" class="error">{{vuelidate.password.$errors[0].$message}}</div>
                <!-- <ErrorHandler :error="userStore.error" keyword="password"/> -->
              </div>
              <div class="form-group">
                <label class="form-label" for="password_confirmation">Confirm Password</label>
                <input
                  type="password"
                  class="form-control form-control-merge"
                  id="password_confirmation"
                  name="password_confirmation"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  aria-describedby="password"
                  tabindex="3"
                  v-model="confirm"
                />
                <div v-if="vuelidate.confirm.$error" class="error">The confirm password value must be equal to the password value</div>
              </div>
              <div class="form-group">
                <label class="form-label" for="role">Role</label>
                <select id="role" name="role" class="form-control" v-model="role">
                  <option value="">Please Select</option>
                  <option v-for="(role, index) in userStore.roles" :value="role.id">{{ role.display_name }}</option>
                </select>
                <div v-if="vuelidate.role.$error" class="error mt-1">{{ vuelidate.role.$errors[0].$message }}</div>
                <!-- <ErrorHandler :error="userStore.error" keyword="role"/> -->
              </div>

              <button type="button" id="submit" name="submit" class="btn btn-primary mr-1" v-if="this.userStore.creatingUser">{{this.userStore.createUser}}</button>
              <button type="button" id="submit" name="submit" class="btn btn-primary mr-1" @click="createUser">{{this.userStore.createUser}}</button>
              <button type="reset" class="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
            </div>
          </form>
        </div>
      </div>
</template>
<script>
import { ref,watch } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email, maxLength, minLength, sameAs, helpers,url  } from '@vuelidate/validators'
import { useUserStore } from '../../../../stores/UserStore'
import ErrorHandler from "../../../auth/ErrorComponent.vue"
export default{
    components:{
        ErrorHandler
    },
    data(){
        return{
            name:'',
            email :'',
            password : '',
            confirm : '',
            role:'',
        }
    },
    setup(){
        const closer = ref();
        return{
            vuelidate: useVuelidate(),
            userStore:useUserStore(),
            closer
        }
    },
    validations () {
        return {
            name:{
                required:helpers.withMessage('Username field cannot be empty', required)
            },
            email : {
                required,
                email
            },
            password: { required,minLength:minLength(8),maxLength:maxLength(24) },
            confirm: { required, sameAs:sameAs(this.password)},
            role:{
                required:helpers.withMessage('Role Field Cannot be Empty', required)
            },
        }
    },
    mounted(){
        this.userStore.fetchRoles();
    },
    methods:{
        createUser(){
            this.vuelidate.$validate();
            let $this = this;
            let params = {
                name:this.name,
                email:this.email,
                password:this.password,
                password_confirmation:this.confirm,
                role:this.role
            }
            const route = this.$router.resolve(
                {
                    name: 'create-user',
                }
            );
            $this.userStore.createUser = 'Creating New User...'
            if(this.vuelidate.$error <= 0 ){
                axios.post(route.href,params).then(({data})=>{
                    console.log(data.error);
                    if(data.error != true){
                        toastr.success(data.message,'Create Success')
                        $this.reset()
                        $this.userStore.createUser = 'Create User'
                        $this.userStore.creatingUser = false
                    }else{
                        toastr.error(data.message,'Create Error')
                        $this.userStore.createUser = 'Create User'
                        $this.userStore.creatingUser = false
                    }
                }).catch((error)=>{
                    $this.userStore.error = this.getError(error)
                    $this.userStore.creatingUser = false
                    $this.userStore.createUser = 'Create User'
                })
            }else{
                $this.userStore.createUser = 'Create User'
                $this.userStore.creatingUser = false
            }
        },
        getError(error){
            const errorMsg = "";

            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        },
        reset(){
            this.vuelidate.$reset()
            this.name = '';
            this.email = '';
            this.password = '';
            this.confirm = '';
            this.role = '';
        }
    }
}
</script>
